import ApiCaller from 'actions/ApiCaller';
import baseAjaxConfig, { headers } from 'actions/BaseAjaxConfig';

export const GET_RETURN_ADDRESSLIST_REQUEST = 'GET_RETURN_ADDRESSLIST_REQUEST';
export const GET_RETURN_ADDRESSLIST_SUCCESS = 'GET_RETURN_ADDRESSLIST_SUCCESS';
export const GET_RETURN_ADDRESSLIST_ERROR = 'GET_RETURN_ADDRESSLIST_ERROR';
export const CREATING_ADDRESS = 'CREATING_ADDRESS';
export const CREATED_ADDRESS = 'CREATED_ADDRESS';

export function getReturnAddressList(token) {
	return dispatch => {
		dispatch(requestAddress());

		return ApiCaller.post(
			Object.assign({}, baseAjaxConfig, {
				headers,
				pathname: `/api/1/self-serve/return/details/getAllAddress/${token}`
			}),
			{}
		).then(
			json => dispatch(receiveAddressSuccess(json['RESPONSE'])),
			err => {
				dispatch(receiveAddressError(err));
				return Promise.reject(err);
			}
		);
	};
}

function requestAddress() {
	return { type: GET_RETURN_ADDRESSLIST_REQUEST };
}

function receiveAddressSuccess(response) {
	return { type: GET_RETURN_ADDRESSLIST_SUCCESS, data: response };
}

function receiveAddressError(err) {
	return { type: GET_RETURN_ADDRESSLIST_ERROR, error: err };
}

export function createAddress(addressObj, token) {
	if (!addressObj || !addressObj.name) return null;
	const {
		name,
		addressLine1,
		addressLine2,
		phone,
		pincode: pinCode,
		state,
		stateCode,
		landmark,
		locationTypeTag
	} = addressObj;
	const postAddress = {
		name,
		addressLine1,
		addressLine2,
		phone,
		pinCode,
		state,
		stateCode,
		country: 'IN',
		landmark,
		locationTypeTag
	};
	return dispatch => {
		dispatch({ type: CREATING_ADDRESS });
		return ApiCaller.post(
			Object.assign({}, baseAjaxConfig, {
				headers,
				pathname: `/api/1/self-serve/return/createAddress/${token}`
			}),
			postAddress
		).then(
			json => {
				dispatch({ type: CREATED_ADDRESS });
				const response = json['RESPONSE'];
				if (response.address && response.address.addressId) {
					return response.address.addressId;
				}
				return null;
			},
			err => {
				dispatch(receiveAddressError(err));
				return null;
			}
		);
	};
}
